/*eslint-disable*/

// src/contexts/RerouteContext.js
// import React, { createContext, useContext, useState } from "react";

// // src/contexts/RerouteContext.js

// export const RerouteContext = createContext();

// export const RerouteProvider = ({ children }) => {
//   const [rerouteType, setRerouteType] = useState(null);

//   return (
//     <RerouteContext.Provider value={{ rerouteType, setRerouteType }}>
//       {children}
//     </RerouteContext.Provider>
//   );
// };

// export const useRerouteContext = () => useContext(RerouteContext);

import React, { createContext, useContext, useState, useEffect } from "react";

export const RerouteContext = createContext();

export const RerouteProvider = ({ children }) => {
    const [rerouteType, setRerouteTypeState] = useState(() => {
        // Load from localStorage on first render
        return sessionStorage.getItem("rerouteType") || null;
    });

    const setRerouteType = type => {
        sessionStorage.setItem("rerouteType", type);
        setRerouteTypeState(type);
    };

    return <RerouteContext.Provider value={{ rerouteType, setRerouteType }}>{children}</RerouteContext.Provider>;
};

export const useRerouteContext = () => useContext(RerouteContext);
